export const SET_LABS = "SET_LABS";
export const UPDATE_LAB_IN_ARRAY = "UPDATE_LAB_IN_ARRAY";
